<template>

<div class="outer_container">
  <div class="left_pane">
    <slot name="left"/>
  </div>
  <div class="center_pane">
    <div class="center_content_container" ref="center_content_container">
      <div class="max_width_wrapper">
        <slot/>
      </div>
    </div>
    <div class="center_footer">
        <div style="max-width: 960px; margin: 0 auto; margin-top: 10px;">
            <v-text-field
                    label="Type a message"
                    v-on:keyup.enter="sendText"
                    v-model="cur_text"
                    autocomplete="off"
                >
                    <template slot="append">
                        <v-icon v-on:click="composeAttachment" style="padding-right: 10px">mdi-image</v-icon>
                        <v-icon v-on:click="sendText">mdi-send-outline</v-icon>
                    </template>
            </v-text-field>  
        </div>
    </div>
  </div>
</div>

</template>

<script>

export default {
    data() {
        return {
            cur_text: ''
        }
    },

    methods: {
        sendText() {
            this.$emit('send-message',this.cur_text);
            this.cur_text = '';
        },

        composeAttachment()
        {
             this.$emit('compose-attachment',this.cur_text);
            this.cur_text = '';
        },

        scrollConversationToBottom()
        {
            let element = this.$refs['center_content_container'];
            element.scrollTop = element.scrollHeight - element.clientHeight;
        }
    },
 
}
</script>

<style lang="scss" scoped>

div.outer_container
{
    display: flex;
    flex-direction: row;

    width: 100%;

    height: calc(100vh - 4.9em);
}

div.left_pane
{
    flex: 0;
    min-width: 22em;
    overflow-y: scroll;
    overflow-x: hidden;
}

div.center_pane
{
    flex: 1;

    display: flex;
    flex-direction: column;

    height: 100%;

    align-items: center;
}

div.center_content_container
{
    flex: 1;
    
    height: 100%;
    width: 100%;

    overflow-x: hidden;
    overflow-y: scroll;

    padding: 0;
    margin: 0;

}

div.max_width_wrapper
{
    margin: 0 auto;
    max-width: 960px;
}

div.center_footer
{
    flex: 0;
    min-height: 4em;


    width: 100%;

    border-top: 1px solid rgba(0,0,0,0.25);

    padding-left: 1em;
    padding-right: 1em;
    margin-top: 3px;
}

div.block
{
    width: 20em;
    height: 20em;

    background-color: green;

    margin: 1em;
}

</style>